module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "pa el-input__inner",
    attrs: {
      "type": "password",
      "maxlength": "39"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": function($event) {
        $event.keyCode === 32 ? $event.preventDefault() : true
      },
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3530dc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/password-validator/PasswordValidator.vue
// module id = 852
// module chunks = 1